import React from 'react';
import ClassName from '../../interfaces/class-name.interface';
import Color from '../../interfaces/color.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import Size from '../../interfaces/size.interface';
import TestId from '../../interfaces/test-id.interface';
import icons from './icons';

export interface Props extends ClassName, Color, Layer, Gap, Size, TestId {
  /** The icon to render */
  name: string;

  /** Determines how the icon is rendered (plain / on a disc / ... - default: "pretext") */
  variant?: 'pretext' | 'plain' | 'disc' | 'circle';
}

/** A component to render SVG icons */
const Icon = ({
  className = '',
  color = 'inherit',
  name,
  gap = 'none',
  layer = 0,
  size = 'inherit',
  variant = 'pretext',
  testId,
}: Props): React.ReactElement => {
  const I: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | undefined = icons.get(name);

  if (!I) {
    return <strong data-testid={testId}>Warning: icon &quot;{name}&quot; was not found</strong>;
  }

  return (
    <div
      className={`
        icon
        inline-block
        ${variant === 'pretext' ? 'mr-2' : ''}
        ${variant === 'circle' ? 'bg-white p-1/2em border-4 rounded-full' : ''}
        ${variant === 'disc' ? 'bg-gray-700 text-white p-1/2em rounded-full' : ''}
        text-${color}
        text-${size}
        gap--${gap}
        layer--${layer}
        ${className}
      `}
      data-testid={testId}
    >
      <I fill="currentColor" height="1em" name={name} vertical-align="baseline" width="1em" />
    </div>
  );
};

export default Icon;
